import { render, staticRenderFns } from "./TableOtherModels.vue?vue&type=template&id=1321eca8"
import script from "./TableOtherModels.vue?vue&type=script&lang=js"
export * from "./TableOtherModels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports